export const en = {
  'ui2-datepicker': {
    inputPlaceholderSingle: 'Choose a date',
    inputPlaceholderRange: 'Choose a date range',
    inputPlaceholderCustom: 'Custom range'
  }
};
